import { useTranslation } from 'react-i18next';
import { Navigate, NavLink, Outlet, useLocation } from 'react-router';

import { cn } from '@/utils/cn';

const tabs = [
  { to: '/account', end: true },
  { to: '/account/devices', end: false },
] as const;

/**
 * Personal account area — profile, security and enrolled devices.
 *
 * Church setup lives under Settings; anything here belongs to the signed-in person.
 */
export const AccountLayout = () => {
  const { t } = useTranslation('auth');
  const location = useLocation();

  if (location.pathname === '/account/') {
    return <Navigate to="/account" replace />;
  }

  return (
    <div>
      <div className="mb-6 flex gap-1 overflow-x-auto overflow-y-hidden border-b border-border">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'relative -mb-px shrink-0 border-b-2 border-transparent px-3 py-2 text-body font-medium whitespace-nowrap',
                'text-fg-secondary transition-colors hover:text-fg',
                isActive && 'border-brand text-brand',
              )
            }
          >
            {tab.to === '/account' ? t('account.tabs.profile') : t('account.tabs.devices')}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
};
